@if (loans$ | async; as loans) {
  <div class="loan-list">
    @if (loans.length > 0) {
      <div class="loan-list-content">
        @for (loan of loans; track loan.id) {
          <app-loan-card [loan]="loan" />
          @if (!$last) {
            <mat-divider></mat-divider>
          }
        }
      </div>
    } @else {
      <div class="no-loans">
        <mat-icon>account_balance</mat-icon>
        <p>No loans belong to your account.</p>
      </div>
    }
  </div>
}
